import { Sortable } from 'sortablejs';
import {Checkbox} from "../../../../../components/checkbox/checkbox";

const USERNAME_SELECTOR: string = "[name='config[virtual][username]']";
const NAME_SELECTOR: string = "[name='config[virtual][name]']";
const UUID_SELECTOR: string = "[name='config[virtual][uuid]']";
const BROADCAST_SELECTOR: string = "[data-broadcast]";

const tableRow = require('../../view/partials/tableRow.handlebars');
const tableHead = require('../../view/partials/tableHead.handlebars');

export class TableViewUI {

  public constructor(private $base: JQuery, public data: any, public form: any) {
    this.renderTableHead(this.form);
    this.$base.find('button').removeAttr('disabled');

    if ($(BROADCAST_SELECTOR).length > 0) {
      const checkboxIndex : number
          = this.$base.find(BROADCAST_SELECTOR).find('.fancy-checkbox input').data('index');
      const checkbox : Checkbox = window.findCheckboxByIndex(checkboxIndex);

      setTimeout(() => {
        this.toggleBroadcast(checkbox);
      }, 1000);

      if (this.$base.find(BROADCAST_SELECTOR).length > 0) {
        checkbox.onChange = () => {
          this.toggleBroadcast(checkbox);
        };
      }
    }
  }

  public toggleBroadcast(checkbox : Checkbox = null) : void {
    if (this.$base.find(BROADCAST_SELECTOR).find('.fancy-checkbox input').length > 0) {
      if (checkbox !== null && checkbox.ui.active == true) {
        this.$base.find('.tableview__form').show();
        this.$base.find('.tableview__data').show();
      } else {
        this.$base.find('.tableview__form').hide();
        this.$base.find('.tableview__data').hide();
      }
    }
  }

  public isMinecraft(): boolean {
    return window.location.href.indexOf('minecraft') > 0;
  }

  public isArk(): boolean {
    return window.location.href.indexOf('ark') > 0;
  }

  public updateUuid(id: string) {
    this.$base.find(UUID_SELECTOR).val(id);
  }

  public onUsernameChange(callback: (value: string) => {}) {
    let timeout;
    this.$base.find(USERNAME_SELECTOR).off('keyup');
    this.$base.find(USERNAME_SELECTOR).on('keyup', (e: any) => {
      window.clearInterval(timeout);

      timeout = window.setTimeout(() => {
        callback(e.currentTarget.value);
      }, 500);
    });
  }

  public clearTable() {
    this.$base.find('.table__row').remove();
  }

  public disbaleUuid() {
    this.$base.find(UUID_SELECTOR).attr('disabled', 'disabled');
  }

  public onNameChange(callback: (value: string) => {}) {
    let timeout;
    this.$base.find(NAME_SELECTOR).off('keyup');
    this.$base.find(NAME_SELECTOR).on('keyup', (e: any) => {
      window.clearInterval(timeout);

      timeout = window.setTimeout(() => {
        callback(e.currentTarget.value);
      }, 500);
    });
  }

  public onAddButtonClick(callback: (data: any) => {}) {
    this.$base.find('.action-headline .button').on('click', (e) => {
      e.preventDefault();
      let row = {};
      this.$base.find('.tableview__form .js-configinput, .tableview__form .fancy-checkbox input').each((i, configinput) => {
        if ($(configinput).is(':checkbox')) {
          let val;
          if ($(configinput).is(':checked')) {
            val = $(configinput).parents('.fancy-checkbox').data('true');
          } else {
            val = $(configinput).parents('.fancy-checkbox').data('false');
          }
          row = { ...row, [$(configinput).parents('.fancy-checkbox').data('name')]: val};
        } else {
          row = { ...row, [$(configinput).data('name')]: $(configinput).val() };
        }
      });
      callback(row);
      return false;
    });
  }

  public onDeleteButtonClick(callback: (index) => {}) {
    this.$base.find('.table .button').on('click', (e) => {
      e.preventDefault();
      callback($(e.currentTarget).data('index'));
    });
  }

  public getTableKey() {
    return this.$base.data('tableview');
  }

  public renderTableHead(tableHeadData) {
    const self = this;

    this.$base.find('.tableview__tablehead').html(tableHead({
      data: tableHeadData,
      tableKey: self.getTableKey()
    }));
  }

  public allowedToReorder() {
    return this.$base.data('reorder') === true;
  }

  public render(data, afterRender: () => {}) {
      this.$base.find('.tableview__data').show();
      this.renderTableHead(this.form);
      const self = this;
      this.$base.find('.table__content').html(tableRow({
          data: data,
          tableKey: self.getTableKey(),
          reorder: this.allowedToReorder()
      }));

      afterRender();
  }

  public sort() {
    if (this.$base.find('.table__content').children.length > 0) {
      Sortable.create(document.getElementById(this.$base.find('.table__content').attr('id')), {
        ghostClass: 'table__row--highlighted',
        forceFallback: true
      });
    }
  }
}
